import { createIcon } from '../createIcon.tsx';

export const GraduationCapIcon = createIcon(
	'GraduationCapIcon',
	<>
		<path d="M22 10 12 5 2 10l10 5z" />
		<path d="M6 12v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5" />
		<line x1="22" y1="10" x2="22" y2="16" />
	</>,
);
